import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { UserAction } from 'redux/actions';
import PropTypes from 'prop-types';
import noImage from 'assets/img/users/no-image.jpg';
import PageSpinner from 'components/PageSpinner';
import { Card, Button, Input } from 'reactstrap';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import DataTables from 'components/dataTables';
import Avatar from 'components/Avatar';
import { Link } from 'react-router-dom';
import _ from "lodash";
import { checkPermissions } from 'hooks';
import PopupWindow from 'components/ModalPopup';
import AddUser from './addUser';
import { DateFormatTimeZone } from 'hooks';

const DeletedUsersList = (props) => {

    const [userOpen, setUserOpen] = React.useState(false);
    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    })
    const [query, setQuery] = useState("");

    const [order, setOrder] = React.useState({
        order_by: 'name',
        direction: 'asc'
    })

    React.useEffect(() => {
        let filters = { query: query, page: pagination.page, page_limit: pagination.page_limit, order_by: order.order_by, direction: order.direction }
        props.getUsers(filters);
    }, [pagination, order]);


    React.useEffect(() => {
        let filters = { query: query, page: pagination.page, page_limit: pagination.page_limit, order_by: order.order_by, direction: order.direction }
        props.getUsers(filters);
        setUserOpen(false);
    }, [props.userAdded]);

    const handleChange = (event) => {
        setQuery(event.target.value);
        debounce(event.target.value);
    };

    const debounce = useCallback(
        _.debounce((searchVal) => {
            let filters = { query: searchVal, page: pagination.page, page_limit: pagination.page_limit, order_by: order.order_by, direction: order.direction }
            props.getUsers(filters);
        }, 1000),
        []
    );

    React.useEffect(() => {
        //setShowLoader(false);
    }, [props.usersList])

    const profilePicture = (value, tableMeta, updateValue) => {
        const lastActive = tableMeta.rowData[8];
        const lastActiveTime = (lastActive) ? DateFormatTimeZone(lastActive, 'MM-DD-YYYY HH:mm:ss') : null;
        const start = new Date(lastActiveTime).getTime();
        return (<div>{((Date.now() - start) <= (1 * 60 * 1000)) && <span style={{ background: '#42bb42', width: '10px', height: '10px', position: 'absolute', borderRadius: '5px', left: '2%' }}></span>}<Avatar src={(value) ? value : noImage} /></div>);
    }

    const columns = [
        {
            name: "id",
            label: "Id",
            options: {
                display: false,

            }
        },
        {
            name: "avatar",
            label: "Image",
            options: {
                customBodyRender: profilePicture,
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={1} itemkey={1} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "name",
            label: "Name",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={2} itemkey={2} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "username",
            label: "Username",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={3} itemkey={3} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "email",
            label: "Email",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={4} itemkey={4} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                },
                setCellProps: () => ({
                    style: { minWidth: "150px", maxWidth: "150px" }
                }),
            }
        },
        {
            name: "phone",
            label: "Phone",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={5} itemkey={5} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "followers_count",
            label: "Followers",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={6} itemkey={6} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "followings_count",
            label: "Followings",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={7} itemkey={7} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "last_interacted",
            label: "Last active",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={8} itemkey={8} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return DateFormatTimeZone(value, 'MM-DD-YYYY HH:mm:ss');
                },
                setCellProps: () => ({
                    style: { minWidth: "150px", maxWidth: "150px" }
                }),
            }
        },
        {
            name: "action",
            label: "Action",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={9} itemkey={9} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return checkPermissions(props.loginData, 'user_profile') ?
                        <Link className={'view-profile-link'} to={`/user-profile/${tableMeta.rowData[0]}`}><Button color="primary" className="border-0" >View Profile</Button></Link>
                        : <Button color="primary" disabled={true} className="border-0 btn-disabled" >View Profile</Button>
                },
                setCellProps: () => ({
                    style: { minWidth: "150px", maxWidth: "150px" }
                }),

            }
        }

    ];
    const options = {
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        searchOpen: false,
        responsive: "simple",
        filter: false,
        download: (checkPermissions(props.loginData, 'users_list_csv')) ? true : false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: props.totalRecord,
        serverSide: (props.serverSide !== undefined) ? props.serverSide : true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })

        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                /*case 'search':
                    setPagination({
                        page_limit: 10,
                        page: 0
                    })
                    setSearchText((tableState.searchText)?tableState.searchText:'');
                    break*/
                default:
                    break
            }
        }
    };
    return (
        <>
            <Input
                type="text"
                name="query"
                id="query"
                onChange={handleChange}
                autoComplete={'off'}
                value={query}
                placeholder={'Search by name or username'}
                style={{ width: 300, marginBottom: 10 }}
            />
            {(checkPermissions(props.loginData, 'create_user')) &&
                <div style={{ width: 100, marginLeft: 'auto', marginBottom: 10 }}>
                    <PopupWindow btnClass={'add-new-user'} handlePopup={(flag) => setUserOpen(flag)} openWindow={userOpen} title={'Add New User'} launchButtonText={'Add New User'} >
                        <AddUser isAdmin={false} />
                    </PopupWindow>
                </div>
            }

            <Card className="mb-3">

                {props.isLoading ? <PageSpinner />
                    : <DataTables data={props.usersList} columns={columns} options={options} />
                }
            </Card>
        </>
    );
}

DeletedUsersList.propTypes = {
    DeletedUsersList: PropTypes.array,
    getUsers: PropTypes.func,
};

const mapStateToProps = (state) => ({
    userAdded: (state.user && state.user.userAdded) ? state.user.userAdded : null,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    usersList: (state.user && state.user.deletedUsers && state.user.deletedUsers.users) ? state.user.deletedUsers.users : [],
    totalRecord: (state.user && state.user.deletedUsers && state.user.deletedUsers.total_users) ? state.user.deletedUsers.total_users : 0
});
const mapDispatchToProps = (dispatch) => ({
    getUsers: (payload) => dispatch(UserAction.getDeletedUsers(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeletedUsersList);